<template>
  <section class="action-bar">
    <div
      v-if="!isSubmitted"
      class="col-md-12 text-right">
      <BaseButton
        v-if="!isHideCloseButton"
        :text="textCancel"
        className="btn-light"
        @click="onCancel"/>
      <BaseButton
        :text="textSubmit"
        :disabled="isDisabledSubmit"
        className="btn-web"
        @click="onSubmit"/>
    </div>
    <div
      v-else
      class="col-md-12 text-right">
      <BaseButton
        v-if="!isHideCloseButton"
        :text="textCancel"
        className="btn-light"
        disabled/>
      <BaseButton
        className="btn-web"
        disabled>
        <i class="fas fa-spinner spin"/>
      </BaseButton>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    isSubmitted: {
      type: Boolean,
      default: false,
    },
    textCancel: {
      type: String,
      default: null,
    },
    textSubmit: {
      type: String,
      default: null,
    },
    isHideCloseButton: {
      type: Boolean,
      default: true,
    },
    isDisabledSubmit: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onCancel () {
      this.$emit('onCancel')
    },
    onSubmit () {
      this.$emit('onSubmit')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseFormAction.vue